"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FAILURE = exports.SUCCESS = exports.REQUEST = void 0;
var REQUEST = function (actionType) { return "".concat(actionType, "_PENDING"); };
exports.REQUEST = REQUEST;
var SUCCESS = function (actionType) { return "".concat(actionType, "_FULFILLED"); };
exports.SUCCESS = SUCCESS;
var FAILURE = function (actionType) { return "".concat(actionType, "_REJECTED"); };
exports.FAILURE = FAILURE;
//# sourceMappingURL=action-type.util.js.map